import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.css";
import Layout from "./Layout";
import { loadAllData } from "./util"
// odd, see https://stackoverflow.com/questions/36795819/when-should-i-use-curly-braces-for-es6-import

// Page imports
import About from "./pages/About";
import Aegerisee from "./pages/Aegerisee";
import Alpnachersee from "./pages/Alpnachersee";
import ChangeLog from "./pages/Changelog";
import Garda from "./pages/Garda";
import Greifensee from "./pages/Greifensee";
import Home from "./pages/Home";
import Impressum from "./pages/Impressum";
import Murtensee from "./pages/Murtensee";
import Neuenburgersee from "./pages/Neuenburgersee";
import Sihlsee from "./pages/Sihlsee";
import Silvaplanersee from "./pages/Silvaplanersee";
import Urnersee from "./pages/Urnersee";
import Weissensee from "./pages/Weissensee";
import Zuerichsee from "./pages/Zuerichsee";
import Walensee from "./pages/Walensee";
import Untersee from "./pages/Untersee";
import Zugersee from "./pages/Zugersee";
import Comersee from "./pages/Comersee";
import Maggiore from "./pages/Maggiore";
import Bielersee from "./pages/Bielersee";
import LacRosel from "./pages/Rosel";
import Hallwilersee from "./pages/Hallwilersee";
import Sempachersee from "./pages/Sempachersee";
import Obersee from "./pages/Obersee";
import Thunersee from "./pages/Thunersee";

// Load weather and lake temperature forecasts once
let forecast = await loadAllData();


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/aegerisee" element={<Aegerisee forecast={forecast} />} />
          <Route path="/about" element={<About />} />
          <Route path="/alpnachersee" element={<Alpnachersee forecast={forecast} />} />
          <Route path="/bielersee" element={<Bielersee forecast={forecast} />} />
          <Route path="/changelog" element={<ChangeLog />} />
          <Route path="/comersee" element={<Comersee forecast={forecast} />} />
          <Route path="/gardasee" element={<Garda forecast={forecast} />} />
          <Route path="/greifensee" element={<Greifensee forecast={forecast} />} />
          <Route path="/hallwilersee" element={<Hallwilersee forecast={forecast} />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/lagomaggiore" element={<Maggiore forecast={forecast} />} />
          <Route path="/lacdurosel" element={<LacRosel forecast={forecast} />} />
          <Route path="/murtensee" element={<Murtensee forecast={forecast} />} />
          <Route path="/neuenburgersee" element={<Neuenburgersee forecast={forecast} />} />
          <Route path="/obersee" element={<Obersee forecast={forecast} />} />
          <Route path="/sempachersee" element={<Sempachersee forecast={forecast} />} />
          <Route path="/sihlsee" element={<Sihlsee forecast={forecast} />} />
          <Route path="/silvaplanersee" element={<Silvaplanersee forecast={forecast} />} />
          <Route path="/thunersee" element={<Thunersee forecast={forecast} />} />
          <Route path="/urnersee" element={<Urnersee forecast={forecast} />} />
          <Route path="/untersee" element={<Untersee forecast={forecast} />} />
          <Route path="/walensee" element={<Walensee forecast={forecast} />} />
          <Route path="/weissensee" element={<Weissensee forecast={forecast} />} />
          <Route path="/zuerichsee" element={<Zuerichsee forecast={forecast} />} />
          <Route path="/zugersee" element={<Zugersee forecast={forecast} />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
